import { useAuth } from "../helpers/Auth";

const useFakeUID = () => {
  const { fakeUID } = useAuth();
  return fakeUID;
};

export const useFakedUID = () => {
  const { effectiveUID } = useAuth();
  return effectiveUID;
};

export default useFakeUID;
